// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__vDBSF","total":"MasterSaleDetails_total__t5MW5","edit":"MasterSaleDetails_edit__+Ko+s","cancel":"MasterSaleDetails_cancel__RKs19"};